import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SwUpdate} from '@angular/service-worker';
import {CommonConstant} from '../../app.constants';
import {appVersion, environment} from '../../../environments/environment';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})

export class VersionComponent implements OnInit {
  public appVersion = appVersion;
  public updateAvailable = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private swUpdate: SwUpdate) {


    swUpdate.checkForUpdate().then(() => {
      swUpdate.available.subscribe(event => {
        console.log(event);
        this.updateAvailable = true;
      });
    });
  }

  ngOnInit() {}

  triggerUpdate() {
    this.swUpdate.activateUpdate().then(() => document.location.reload());
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/version/version.component.ts